/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback, useRef, useState } from 'react';
import clsx from 'clsx';
import customStyles from "../../../assets/styles/customStyles";
import MainHeader from "../../Shared/components/Header";
import { Row, Col } from "antd";
import Menus from "./Menus";
import { useParams } from "react-router-dom";
import SalesIcon from "../../../assets/images/icon_menus/SalesIcon.json";
import { Trend, MonthlySales, Total, LastDays, Location, OverDue, NoData, Top5Customers } from "../../Shared/components/Dashboard";
import { Swiper, SwiperSlide } from "swiper/react";
import { checkModuleViewPermission, storageGetItem } from '../../../helpers/utilities';
import { useDispatch, useSelector } from "react-redux";
import SwiperCore, {
    Navigation,
    Pagination,
    Autoplay,
    Virtual
} from "swiper/core";
import action from "./redux/actions";

SwiperCore.use([Navigation, Pagination, Autoplay, Virtual]);

const Sales = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { salesDashboardDetails, salesDashboardLoader } = useSelector(state => state.salesDashboardReducer);
    const [height, setHeight] = useState(300);
    const [menuHeight, setMenuHeight] = useState(0);
    const leftRef = useRef('');
    const dispatch = useDispatch();
    const swiperRef = useRef();
    const { history } = props;
    const { slide } = useParams();


    const handleMouseEnter = () => {
        if (swiperRef.current) swiperRef.current.autoplay.start();
    };
    const handleMouseLeave = () => {
        if (swiperRef.current) swiperRef.current.autoplay.stop();
    };

    const calculateHeight = () => {
        if (document.querySelectorAll(`.menuCheck`).length > 0) {
            if (leftRef && leftRef?.current)
                setMenuHeight(leftRef.current.offsetHeight + 25);
            if (document.querySelectorAll(`.${classes.primaryMenu}`) && document.querySelectorAll(`.${classes.primaryMenu}`).length > 0 && leftRef.current) {
                let height = document.querySelectorAll(`.${classes.primaryMenu}`)[0].offsetHeight;
                let offsetHeight = leftRef?.current?.offsetHeight + height + 23;
                setHeight(offsetHeight);
            }
        }
    }

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkModuleViewPermission('Sales', history)) {
                loadTasks();
                setTimeout(() => {
                    calculateHeight();
                }, 100);
                window.removeEventListener('resize', calculateHeight());
                window.addEventListener('resize', calculateHeight());
            }
        }
        return () => window.removeEventListener('resize', calculateHeight());
    }, [roleManagement]);


    useEffect(() => {
        if (slide) {

        }
    }, [slide]);

    const loadTasks = useCallback(() => {
        dispatch({ type: action.SALES_DASHBOARD_START, url: 'salesdashboard' });
    });

    const classes = customStyles();

    return (
        <React.Fragment>
            <MainHeader {...props} cls={'newImg'}
                img={SalesIcon} title={'Sales'} links={[{ 'label': 'Home', 'link': '/' }, { 'label': 'Sales', 'link': '' }]} close={false} />
            <div className={clsx(classes.listTableMargin, classes.containerBorder, classes.cardEHeight)}>
                <Row gutter={20} className={classes.dashboardRow}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={16} xxl={16}>
                        <Row gutter={25} ref={leftRef}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                <div className={clsx(classes.boxBorder)}>
                                    <div className={clsx(classes.boxBorderInner)}>
                                        {
                                            salesDashboardDetails !== undefined && salesDashboardDetails !== '' ?
                                                <Swiper
                                                    initialSlide={slide ? parseInt(slide) : false}
                                                    //activeIndex={3}
                                                    //activeSlide={slide ? slide : 1}
                                                    id="swiper"
                                                    virtual
                                                    // autoplay={{
                                                    //     delay: 5000,
                                                    //     pauseOnMouseEnter: true
                                                    // }}
                                                    allowTouchMove={false}
                                                    loop
                                                    pagination={{ clickable: true }}>
                                                    <SwiperSlide key={`1`} style={{ listStyle: "none" }}>
                                                        {
                                                            salesDashboardDetails?.invoices.reduce((a, v) => a = a + v, 0) === 0 ? <NoData /> : <Trend title="Sales Trend"
                                                                toolTip="Values displayed includes only original transaction data and does not include any reversals or credit note"
                                                                dataVisible={salesDashboardDetails?.total_sales_15}
                                                                months={salesDashboardDetails?.months}
                                                                invoiceCounts={salesDashboardDetails?.invoices}
                                                                invoiceAmounts={salesDashboardDetails?.amounts}
                                                            />
                                                        }
                                                    </SwiperSlide>
                                                    <SwiperSlide key={`2`} style={{ listStyle: "none" }}>
                                                        {
                                                            salesDashboardDetails?.currentMonth_top_saled_customer?.length === 0 ? <NoData /> : <Top5Customers
                                                                title="Current Month Top 5 Customer" details={salesDashboardDetails}
                                                            />
                                                        }
                                                    </SwiperSlide>
                                                </Swiper>
                                                : <div className={classes.loadMoreCircle}></div>
                                        }
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12} className={classes.secondBox}>
                                <div className={clsx(classes.boxBorder)}>
                                    <div className={clsx(classes.boxBorderInner)}>
                                        {
                                            salesDashboardDetails !== undefined && salesDashboardDetails !== '' ?
                                                <>
                                                    {
                                                        salesDashboardDetails?.current_month_total === 0
                                                            && salesDashboardDetails?.last_month_total === 0 ? <NoData /> :
                                                            <MonthlySales title="Monthly Sales Comparison"
                                                                toolTip="Values displayed includes only original transaction data and does not include any reversals or credit note"
                                                                sTitle="Sales"
                                                                loader={salesDashboardLoader}
                                                                dataVisible={salesDashboardDetails?.total_sales_15}
                                                                monthPercent={salesDashboardDetails?.month_percent}
                                                                currentMonthTotal={salesDashboardDetails?.current_month_total}
                                                                lastMonthTotal={salesDashboardDetails?.last_month_total}
                                                                percent_type={salesDashboardDetails?.percent_type}
                                                            />
                                                    }
                                                </>
                                                : <div className={classes.loadMoreCircle}></div>
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {
                            roleManagement !== '' && <Menus menuHeight={menuHeight} />
                        }
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} className={classes.thirdBox}>
                        <div className={clsx(classes.boxBorderH)} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ height: (height) + 'px' }}>
                            {
                                salesDashboardDetails !== undefined && salesDashboardDetails !== '' ?
                                    <>
                                        {
                                            salesDashboardDetails?.total_sales_15 === 0 &&
                                                salesDashboardDetails?.total_sales_30 === 0 &&
                                                salesDashboardDetails?.total_sales_90 === 0 &&
                                                salesDashboardDetails?.customer_sales_30?.length === 0 &&
                                                salesDashboardDetails?.customer_sales_120?.length === 0 &&
                                                salesDashboardDetails?.customer_sales_300?.length === 0 &&
                                                salesDashboardDetails?.over_due_0_15?.length === 0 &&
                                                salesDashboardDetails?.over_due_15_30?.length === 0 &&
                                                salesDashboardDetails?.over_due_30_45?.length === 0 &&
                                                salesDashboardDetails?.over_due_more_45?.length === 0 &&
                                                salesDashboardDetails?.top_saled_city_30 === null &&
                                                salesDashboardDetails?.top_saled_city_120 === null &&
                                                salesDashboardDetails?.top_saled_city_300 === null
                                                ? <NoData /> : <Swiper
                                                    initialSlide={slide ? parseInt(slide) : false}
                                                    //activeIndex={3}
                                                    //activeSlide={slide ? slide : 1}
                                                    id="swiper"
                                                    virtual
                                                    autoplay={{
                                                        delay: 5000,
                                                        pauseOnMouseEnter: true
                                                    }}
                                                    allowTouchMove={false}
                                                    loop
                                                    pagination={{ clickable: true }}>
                                                    <SwiperSlide key={`1`} style={{ listStyle: "none" }}>
                                                        {
                                                            salesDashboardDetails?.total_sales_15 === 0 &&
                                                                salesDashboardDetails?.total_sales_30 === 0 &&
                                                                salesDashboardDetails?.total_sales_90 === 0 ? <NoData /> :
                                                                <Total title="Total Sales"
                                                                    toolTip="Values displayed includes only original transaction data and does not include any reversals or credit note"
                                                                    sTitle={"Sales Total"} total_sales_15={salesDashboardDetails?.total_sales_15}
                                                                    total_sales_30={salesDashboardDetails?.total_sales_30}
                                                                    total_sales_90={salesDashboardDetails?.total_sales_90} />
                                                        }
                                                    </SwiperSlide>
                                                    {
                                                        (storageGetItem('businessType') === 'AGENT/DEALER' ||
                                                            storageGetItem('businessType') === 'WHOLESALE' ||
                                                            storageGetItem('businessType') === 'DISTRIBUTOR' ||
                                                            storageGetItem('businessType') === 'MANUFACTURER' ||
                                                            storageGetItem('businessType') === 'OTHER') &&
                                                        storageGetItem('isPaying') && <SwiperSlide key={`2`} style={{ listStyle: "none" }}>
                                                            {
                                                                salesDashboardDetails?.customer_sales_30?.length === 0 &&
                                                                    salesDashboardDetails?.customer_sales_120?.length === 0 &&
                                                                    salesDashboardDetails?.customer_sales_300?.length === 0 ? <NoData /> :
                                                                    <LastDays title="Sales By customer" salesDashboardDetails={salesDashboardDetails} />
                                                            }
                                                        </SwiperSlide>
                                                    }
                                                    {
                                                        (storageGetItem('businessType') === 'MANUFACTURER' ||
                                                            storageGetItem('businessType') === 'AGENT/DEALER' ||
                                                            storageGetItem('businessType') === 'WHOLESALE' ||
                                                            storageGetItem('businessType') === 'DISTRIBUTOR') &&
                                                        storageGetItem('isPaying') && <SwiperSlide key={`3`} style={{ listStyle: "none" }}>
                                                            {
                                                                salesDashboardDetails && salesDashboardDetails?.top_saled_city_30 === null &&
                                                                    salesDashboardDetails?.top_saled_city_120 === null &&
                                                                    salesDashboardDetails?.top_saled_city_300 === null ? <NoData /> :
                                                                    <Location title="Sales by Location" salesDashboardDetails={salesDashboardDetails} calculateHeight={() => calculateHeight()} />
                                                            }
                                                        </SwiperSlide>
                                                    }
                                                    {
                                                        (storageGetItem('businessType') === 'AGENT/DEALER' ||
                                                            storageGetItem('businessType') === 'WHOLESALE' ||
                                                            storageGetItem('businessType') === 'DISTRIBUTOR' ||
                                                            storageGetItem('businessType') === 'MANUFACTURER' ||
                                                            storageGetItem('businessType') === 'OTHER') &&
                                                        storageGetItem('isPaying') && <SwiperSlide key={`4`} style={{ listStyle: "none" }}>
                                                            {
                                                                salesDashboardDetails?.over_due_0_15?.length === 0 &&
                                                                    salesDashboardDetails?.over_due_15_30?.length === 0 &&
                                                                    salesDashboardDetails?.over_due_30_45?.length === 0 &&
                                                                    salesDashboardDetails?.over_due_more_45?.length === 0 ? <NoData /> :
                                                                    <OverDue type={'sales'} title="Overdue Customer Payments" salesDashboardDetails={salesDashboardDetails} />
                                                            }
                                                        </SwiperSlide>
                                                    }
                                                </Swiper>
                                        }
                                    </> : <div className={classes.loadMoreCircle}></div>
                            }
                        </div>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default Sales